import DSBox from '../design-system/DSBox';
import DSCircularProgress from '../design-system/DSCircularProgress';
import { DSTypography } from '../design-system/Typography';
import useContractContent from '../hooks/useContractContent';

type ContractProps = {
  html?: string;
  isLoading?: boolean;
};

const Contract = ({
  html: htmlProp,
  isLoading: isLoadingProp,
}: ContractProps) => {
  const { data, isPending, error } = useContractContent({
    enabled: !htmlProp,
  });

  const html = htmlProp ?? data?.html;
  const isLoading = isLoadingProp ?? isPending;

  if (isLoading) {
    return (
      <DSBox sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <DSCircularProgress />
      </DSBox>
    );
  }

  if (error && !html) {
    return (
      <DSBox sx={{ p: 4, textAlign: 'center' }}>
        <DSTypography color="error">
          Unable to load contract content. Please try again later.
        </DSTypography>
      </DSBox>
    );
  }

  if (!html) {
    return null;
  }

  return (
    <DSBox
      sx={{
        '& p': { margin: '0.5em 0' },
        '& a': { color: 'primary.main' },
      }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default Contract;
